import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { FaCheck, FaUserMinus } from "react-icons/fa";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { confirmAlert } from "react-confirm-alert";
import toastr from "toastr";
import moment from "moment";

import { ACTIVE_MODULE } from "app/_constants/constant";

import {
  absentTraineeStatus,
  addTrainingToBatch,
  getAllTrainingBatches,
  removeTraineeStatue,
  updateAssignersStatus,
} from "app/_services/ehs/ehsTrainingServices";
import { isUserVTO } from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Helper";
import { useCategory, useForm } from "app/_helpers/hooks";
import { TRAINING_STATUS } from "../CONSTANTS";
import { isBefore } from "app/_helpers/dateHelper";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import Decline from "app/_pages/_healthSafetyEnvironment/IncidentManagement/DeclinePopup";
import FormBtn from "app/Components/CommanComponents/FormBtn";
import FormSelect from "app/Components/_form/FormSelect/FormSelect";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import FormInput from "app/Components/_form/FormInput/FormInput";
import FormDateTimePicker from "app/Components/_form/FormDatePicker/FormDateTimePicker";
import { isAfter } from "app/_helpers/dateHelper";
import TrainingBatchTab from "../Assign/Component/TrainingBatchTab";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";

import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";

const initialFilter = {
  centerName: "",
  centerCode: "",
  batchId: "",
  duration: "",
  trainingDate: "",
  trainingCategory: "",
  trainingSubCategory: "",
};

function TrainingBatches({
  match: {
    params: { siteId },
  },
}) {
  const [tab, setTab] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [showFilterBtn, setShowFilterBtn] = useState(true);
  // const [batches, setBatches] = useState([]);
  // const [initialBatches, setInitialBatches] = useState([]);
  // const [trainings, setTrainings] = useState([]);
  // const [tableList, setTableList] = useState([]);
  // const [search, setSearch] = useState("");

  // const [selectedBatchId, setSelectedBatchId] = useState(null);
  // const [selectedBatch, setSelectedBatch] = useState(null);
  // const [showModal, setShowModal] = useState(false);
  // const [form, setForm] = useState({});
  // const [filters, onChangeFilter, setFilters] = useForm({
  //   ...initialFilter,
  // });
  // const [category, categoryOption] = useCategory("filter[source]=training");

  // const apiFilter = siteId ? "filter[siteId]=" + siteId : "";

  // const onChangeBatch = ({ target: { name, value, type, checked } }) => {
  //   setForm((prevForm) => {
  //     const updates = {
  //       ...prevForm,
  //       [name]: type === "checkbox" ? checked : value,
  //     };

  //     return { ...updates };
  //   });
  // };

  // const dueTraining = useMemo(() => {
  //   if (!selectedBatch) return [];

  //   return trainings
  //     .filter((d) => d.trainingStatus === TRAINING_STATUS.due && d.trainingType === selectedBatch?.traineeList?.find((d) => d.id)?.trainingType)
  //     .map((d) => ({ label: d.traineeID, id: d.id }));
  // }, [selectedBatch, trainings]);

  // //
  // const initialData = useCallback(async () => {
  //   getAllTrainingBatches(apiFilter).then((response) => {
  //     if (!response?.data) return;

  //     setBatches(response?.data);
  //     setInitialBatches(response?.data);
  //     setTrainings(response?.data);
  //   });
  // }, [apiFilter]);

  // const onClickRow = useCallback((row) => {
  //   setSelectedBatchId(row?.id);
  //   setSearch("");
  //   setSelectedBatch(row);
  // }, []);

  // const onSubmit = useCallback(
  //   async (obj, extraObj) => {
  //     const result = await updateAssignersStatus(obj);

  //     if (result?.status) {
  //       toastr.success(result?.message || "Success");

  //       initialData();
  //     }
  //   },
  //   [initialData]
  // );

  // const onSubmitBatch = useCallback(async () => {
  //   if (!form?.trainingId) return toastr.info("Please select training");

  //   const obj = {
  //     traineesId: [form?.trainingId],
  //     batchId: selectedBatchId,
  //   };

  //   const result = await addTrainingToBatch(obj);

  //   if (result?.status) {
  //     toastr.success(result?.message || "Success");

  //     initialData();
  //     setShowModal(false);
  //     setForm({});
  //   }
  // }, [form?.trainingId, initialData, selectedBatchId]);

  // const removeUser = useCallback(
  //   (e, id) => {
  //     e.preventDefault();

  //     confirmAlert({
  //       title: "Remove user",
  //       message: "Do you want to proceed?",
  //       buttons: [
  //         {
  //           label: "Yes",
  //           onClick: async () => {
  //             let response = await removeTraineeStatue(id);

  //             if (response?.status) initialData();
  //           },
  //         },
  //         {
  //           label: "No",
  //           onClick: () => {},
  //         },
  //       ],
  //     });
  //   },
  //   [initialData]
  // );

  // const absentUser = useCallback(
  //   (e, id) => {
  //     e.preventDefault();

  //     confirmAlert({
  //       title: "Absent user",
  //       message: "Do you want to proceed?",
  //       buttons: [
  //         {
  //           label: "Yes",
  //           onClick: async () => {
  //             let response = await absentTraineeStatus(id);

  //             if (response?.status) initialData();
  //           },
  //         },
  //         {
  //           label: "No",
  //           onClick: () => {},
  //         },
  //       ],
  //     });
  //   },
  //   [initialData]
  // );

  // const sortableColumn = selectedBatchId
  //   ? [
  //       {
  //         dataField: "sid",
  //         text: "S.No.",
  //         sort: true,
  //       },
  //       {
  //         dataField: "traineeTypeView",
  //         text: "Trainee Type",
  //         sort: true,
  //       },
  //       {
  //         dataField: "traineeName",
  //         text: "Trainee Name",
  //         sort: true,
  //       },
  //       {
  //         dataField: "trainingTypeView",
  //         text: "Training Type",
  //         sort: true,
  //       },
  //       {
  //         dataField: "ehsSite.name",
  //         text: "Mines Name",
  //         sort: true,
  //       },
  //       {
  //         dataField: "centerName",
  //         text: "Name of Centre",
  //         sort: true,
  //       },
  //       {
  //         dataField: "centerCode",
  //         text: "Centre Code",
  //         sort: true,
  //       },
  //       {
  //         dataField: "batchId",
  //         text: "Batch ID",
  //         sort: true,
  //       },
  //       {
  //         dataField: "duration",
  //         text: "Duration",
  //         sort: true,
  //       },
  //       // {
  //       //   dataField: "minesArea",
  //       //   text: "Mines Area",
  //       //   sort: true,
  //       // },
  //       {
  //         dataField: "trainingCategoryName",
  //         text: "Training Category",
  //         sort: true,
  //       },
  //       {
  //         dataField: "trainingSubCategoryName",
  //         text: "Training Sub-Category",
  //         sort: true,
  //       },
  //       {
  //         dataField: "trainingStatusView",
  //         text: "Status",
  //         sort: true,
  //       },
  //       {
  //         dataField: "ID",
  //         text: "Action",
  //         sort: true,
  //         formatter: (cell, row, rowIndex) => {
  //           return (
  //             <div className="actionIconsGroup">
  //               {row.trainingStatus === TRAINING_STATUS.scheduled && isUserVTO() && (
  //                 <>
  //                   <Decline
  //                     onSubmit={(obj) =>
  //                       onSubmit({
  //                         ...obj,
  //                         assigneeIds: [row.id],
  //                         trainingStatus: TRAINING_STATUS.soReview,
  //                       })
  //                     }
  //                     title="Approve"
  //                     name={
  //                       <CustomTooltip tooltip="Approve">
  //                         <FaCheck />
  //                       </CustomTooltip>
  //                     }
  //                     iconClass={"icons text-success"}
  //                   />

  //                   <CustomTooltip tooltip="Absent">
  //                     <span
  //                       // href="#"
  //                       className="icons text-warning pointer"
  //                       onClick={(e) => absentUser(e, row.id)}
  //                     >
  //                       <FaUserMinus />
  //                     </span>
  //                   </CustomTooltip>

  //                   <CustomTooltip tooltip="Remove">
  //                     <span
  //                       // href="#"
  //                       className="icons text-danger  pointer"
  //                       onClick={(e) => removeUser(e, row.id)}
  //                     >
  //                       <AiOutlineCloseCircle />
  //                     </span>
  //                   </CustomTooltip>
  //                 </>
  //               )}

  //               {/* {row.trainingStatus === TRAINING_STATUS.soReview && isUserSO() && (
  //                 <>
  //                   <Decline
  //                     onSubmit={(obj) =>
  //                       onSubmit({
  //                         ...obj,
  //                         assigneeIds: [row.id],
  //                         trainingStatus: TRAINING_STATUS.mmReview,
  //                       })
  //                     }
  //                     title="Approve"
  //                     name={
  //                       <CustomTooltip tooltip="Approve">
  //                         <FaCheck />
  //                       </CustomTooltip>
  //                     }
  //                     iconClass={"icons text-success"}
  //                   />

  //                   <Decline
  //                     onSubmit={(obj) =>
  //                       onSubmit({
  //                         ...obj,
  //                         assigneeIds: [row.id],
  //                         trainingStatus: row.trainingStatus,
  //                         isBack: 1,
  //                       })
  //                     }
  //                     title="Reject"
  //                     name={
  //                       <CustomTooltip tooltip="Reject">
  //                         <FaTimes />
  //                       </CustomTooltip>
  //                     }
  //                     iconClass={"icons text-danger"}
  //                   />
  //                 </>
  //               )}

  //               {row.trainingStatus === TRAINING_STATUS.mmReview && isUserMM() && (
  //                 <>
  //                   <Decline
  //                     onSubmit={(obj) =>
  //                       onSubmit({
  //                         ...obj,
  //                         assigneeIds: [row.id],
  //                         trainingStatus: TRAINING_STATUS.completed,
  //                       })
  //                     }
  //                     title="Approve"
  //                     name={
  //                       <CustomTooltip tooltip="Approve">
  //                         <FaCheck />
  //                       </CustomTooltip>
  //                     }
  //                     iconClass={"icons text-success"}
  //                   />

  //                   <Decline
  //                     onSubmit={(obj) =>
  //                       onSubmit({
  //                         ...obj,
  //                         assigneeIds: [row.id],
  //                         trainingStatus: row.trainingStatus,
  //                         isBack: 1,
  //                       })
  //                     }
  //                     title="Reject"
  //                     name={
  //                       <CustomTooltip tooltip="Reject">
  //                         <FaTimes />
  //                       </CustomTooltip>
  //                     }
  //                     iconClass={"icons text-danger"}
  //                   />
  //                 </>
  //               )} */}
  //             </div>
  //           );
  //         },
  //       },
  //     ]
  //   : [
  //       {
  //         dataField: "sid",
  //         text: "S.No.",
  //         sort: true,
  //       },
  //       {
  //         dataField: "batchId",
  //         text: "Batch ID",
  //         sort: true,
  //       },
  //       {
  //         dataField: "trainingDateView",
  //         text: "Date of Training",
  //         sort: true,
  //       },
  //       {
  //         dataField: "centerName",
  //         text: "Name of Centre",
  //         sort: true,
  //         formatter: (cell, row, rowIndex) => {
  //           return (
  //             <span className="icons pointer text-cyanBlue" onClick={() => onClickRow(row)}>
  //               {row.centerName}
  //             </span>
  //           );
  //         },
  //       },
  //       {
  //         dataField: "centerCode",
  //         text: "Centre Code",
  //         sort: true,
  //       },
  //       {
  //         dataField: "areaName",
  //         text: "Area",
  //         sort: true,
  //       },
  //       {
  //         dataField: "trainingCategoryName",
  //         text: "Training Category",
  //         sort: true,
  //       },
  //       {
  //         dataField: "duration",
  //         text: "Duration (Days)",
  //         sort: true,
  //       },
  //       {
  //         dataField: "count",
  //         text: "Count",
  //         sort: true,
  //       },
  //     ];

  // const subcategoryOption = useMemo(
  //   () => (category.find((x) => x.id === filters.trainingCategory)?.subCategory || []).map((d) => ({ label: d.name, id: d.id })),
  //   [category, filters.trainingCategory]
  // );

  // useEffect(() => setFilters((prev) => ({ ...prev, trainingSubCategory: "" })), [filters.trainingCategory, setFilters]);

  // useEffect(() => {
  //   initialData();
  // }, [initialData]);

  // useEffect(() => {
  //   setTableList(
  //     selectedBatchId
  //       ? batches.find((d) => d.id === selectedBatchId)?.traineeList || []
  //       : batches.filter((row) => {
  //           for (const key in filters) {
  //             if (!filters[key]) continue;
  //             if (!row[key] || !row[key].toString?.()?.toLowerCase().includes(filters[key].toString().toLowerCase())) return false;
  //           }

  //           if (!search) return true;

  //           if (row.traineeList?.find((t) => t.traineeName?.toLowerCase().includes(search.toLowerCase()))) return true;

  //           for (const key in row) {
  //             if (typeof row[key] !== "string" && typeof row[key] !== "number") continue;

  //             if (row[key].toString().toLowerCase().includes(search.toLowerCase())) return true;
  //           }

  //           return false;
  //         })
  //   );
  // }, [batches, selectedBatchId, search, filters]);

  // const resetBatch = () => {
  //   setSelectedBatchId(null);
  //   setSelectedBatch(null);
  //   setSearch("");
  // };

  // const addToBatch = () => {
  //   setShowModal(true);
  // };

  // const CustomSearch = useCallback(() => {
  //   return (
  //     <label htmlFor="search-bar-0" className="search-label">
  //       <span className="sr-only">Search this table</span>
  //       <input
  //         id="search-bar-0"
  //         type="text"
  //         aria-label="enter text you want to search"
  //         className="form-control mb-0"
  //         placeholder="Search"
  //         onChange={(e) => setSearch(e.target.value)}
  //       />
  //     </label>
  //   );
  // }, []);

  // useEffect(() => {
  //   let data = [];
  //   if (tab === 1) {
  //     data = initialBatches.filter((row) => !(row.traineeList.filter((d) => d.trainingStatus === TRAINING_STATUS.scheduled).length > 0));
  //   } else if (tab === 2) {
  //     data = initialBatches.filter((row) => row.traineeList.filter((d) => d.trainingStatus === TRAINING_STATUS.scheduled).length > 0 && isBefore(moment(), row?.trainingDate));
  //   }

  //   setTableList(data);
  // }, [initialBatches, tab]);

  useEffect(() => {
    setShowFilterBtn(true);
  }, [tab]);

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Training Management",
            path: "/health-safety-and-environment/training-management",
          },
          { name: "Training Batches" },
        ]}
        module={ACTIVE_MODULE.training}
      />
      <div className="healthSafetyEnvironmentWrapper incidentMenu">
        <div className="hseMenuLinks card pointer" style={{ minHeight: 75 }}>
          <a className={`${tab === 1 ? "active" : ""}`} href onClick={() => setTab(1)}>
            Upcoming Batches
          </a>
          <a className={`${tab === 2 ? "active" : ""}`} href onClick={() => setTab(2)}>
            Completed Batches
          </a>
        </div>
      </div>
      <div className="card p-3 my-3">
        {/* {selectedBatchId && isUserVTO() && (
          <div
            style={{
              marginRight: "315px",
              position: "absolute",
              right: 0,
              top: "9px",
            }}
          >
            <Button onClick={addToBatch}>Create Batch</Button>
          </div>
        )} */}
        <div className="simple-card-title">
          <h3 className="text-capitalize mb-1">
            {tab === 2 ? "Completed" : "Upcoming"} Batches
          </h3>
          {showFilterBtn && <FilterBtn setShowFilter={setShowFilter} />}
          <BackBtn url="/health-safety-and-environment/training-management" />
        </div>
        {/* <div className="row mb-3 mx-0">
          <Col lg={3}>
            <FormInput label={"Name of Center"} name="centerName" value={filters.centerName} onChange={onChangeFilter} />
          </Col>
          <Col lg={3}>
            <FormInput label={"Center Code"} name="centerCode" value={filters.centerCode} onChange={onChangeFilter} />
          </Col>
          <Col lg={3}>
            <FormInput label={"Batch ID"} name="batchId" value={filters.batchId} onChange={onChangeFilter} />
          </Col>
          <Col lg={3}>
            <FormInput label={"Duration"} name="duration" value={filters.duration} onChange={onChangeFilter} />
          </Col>
          <Col lg={3}>
            <FormDateTimePicker
              value={filters.trainingDate}
              name="trainingDate"
              onChangeDate={onChangeFilter}
              timeFormat={"HH:mm:ss"}
              dateFormat="YYYY-MM-DD"
              label={"Date of Training"}
            />
          </Col>
          <Col lg={3}>
            <FormSelect
              label={"Training Category"}
              name="trainingCategory"
              value={filters.trainingCategory}
              onChange={onChangeFilter}
              options={categoryOption}
              blankSelect={"Select"}
              menuPortalTarget={null}
            />
          </Col>
          <Col lg={3}>
            <FormSelect
              label={"Training Sub Category"}
              name="trainingSubCategory"
              value={filters.trainingSubCategory}
              onChange={onChangeFilter}
              options={subcategoryOption}
              blankSelect={"Select"}
              menuPortalTarget={null}
            />
          </Col>
          <Col lg={3}>
            <div className="my-2 py-3">
              <button className="ml-5 btn btn-primary" type="button" onClick={() => setFilters({ ...initialFilter })}>
                Reset
              </button>
            </div>
          </Col>
        </div> */}
        {/* {selectedBatchId ? (
          <SearchBootstrapTable data={tableList} columns={sortableColumn} />
        ) : (
          <div>
            <SearchBootstrapTable data={tableList} columns={sortableColumn} CustomSearch={CustomSearch} />
          </div>
        )} */}
        <TrainingBatchTab
          tab={tab}
          showFilter={showFilter}
          setShowFilterBtn={setShowFilterBtn}
        />
        {/* {selectedBatchId && (
          <div className="mt-2 text-center">
            <Button onClick={resetBatch}>Back</Button>
          </div>
        )}
        <AddTrainingToBatchModal
          onChange={onChangeBatch}
          show={showModal}
          onHide={setShowModal}
          form={form}
          onSubmit={onSubmitBatch}
          trainings={dueTraining}
          title={"Create Batch"}
        /> */}
      </div>
    </>
  );
}

// function AddTrainingToBatchModal({ show, onHide, title = "Modal title", form, onChange, error, onSubmit, trainings, selectedBatch }) {
//   const handleClose = () => onHide(false);

//   return (
//     <>
//       <Modal
//         show={show}
//         onHide={handleClose}
//         backdrop="static"
//         keyboard={false}
//         // size="lg"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>{title}</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <Row>
//             <Col lg={12}>
//               <FormSelect
//                 label={"Training"}
//                 name="trainingId"
//                 value={form?.trainingId}
//                 onChange={onChange}
//                 options={trainings}
//                 error={error?.trainingId}
//                 blankSelect={"Select"}
//                 menuPortalTarget={null}
//               ></FormSelect>
//             </Col>
//           </Row>
//         </Modal.Body>

//         <Modal.Footer className="justify-content-center">
//           {/* <Button variant="secondary" onClick={handleClose}>
//             Close
//           </Button>
//           <Button variant="primary" onClick>Understood</Button> */}
//           <FormBtn className="" backBtnTitle={"Close"} backOnClick={handleClose} onSubmit={onSubmit} />
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// }

export default TrainingBatches;
